// extracted by mini-css-extract-plugin
export default {"root":"WY_Wtu","alert":"Zpajo9","icon":"QLpr0a","title":"VMSj6c","description":"ZHUsvU","info":"qAfewp","infoIcon":"EaID1O"};